export const appMap = {
  "1461564080052506636": {
    appKey: "03pNxK2lEXsKiiwrBQ9GbH541Fk2Sfnc"
  },
  '1473207032642564097': {
    appKey: 'KzWN6fGccA9QYDZnBY0foK3hpejfrAxo'
  },
  "1486637108889305089": {
    appKey: "wVC9gUtJNIDzAqOjIVdIHqU3MY6zF6SR"
  },
  '1494278107449683969': {
    appKey: 'plCg0dlpnckfZ2iJhyEPjq58nNvTETgP'
  },
  '1568135068418641921': {
    appKey: 'gLdQUWoefzz3MW0SDBOojkDl9gdicWMc'
  },
  "2109931702132596738": {
    appKey: "CEyXikNZ7FfHW7yKjrjo0ODKOJXJP3a1"
  }
}

export const requestUrlMap = {
  1: 'https://prod-hellosud-base.s00.tech',
  2: 'https://sim-hellosud-base.s00.tech',
  3: 'https://fat-hellosud-base.s00.tech',
  4: 'https://dev-hellosud-base.s00.tech'
}

export const cpRequestUrlMap = {
  1: 'https://prod-hellosud-cp.s00.tech',
  2: 'https://sim-hellosud-cp.s00.tech',
  3: 'https://fat-hellosud-cp.s00.tech',
  4: 'https://dev-hellosud-cp.s00.tech'
}
